import { extendTheme } from "@chakra-ui/react"


export const CustomTheme = extendTheme({
    colors: {
      blue: {
        300: "#15BDF9",
        400: "#049AE1",
        500: "#008BCC",
        600: "#097EBF",
        700: "#1F629F",
        800: "#0A467E",
        900: "#043152",
      },
    },

    fonts: {
      heading: "Lexend, sans-serif",
      body: "Satoshi, sans-serif",
    },

    fontSizes: {
     xxs: "0.625rem",
      xs: "0.75rem",
      sm: "0.875rem",
      md: "1rem",
      lg: "1.25rem",
      xl: "1.375rem",
      "2xl": "1.5rem",
      "3xl": "1.875rem",
      "4xl": "2.25rem",
      "5xl": "3rem",
      "6xl": "3.75rem",
    }, 
    
    fontWeights: {
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },   
  })